module.exports = __webpack_public_path__ + "img/small-19.1e13ea4f.webp";